module.exports = {
  SUBMITTED: 1,
  PROCESSING: 2,
  ACCEPTED: 3,
  DEPOSITED: 4
};